import loadSpecificCombatantActions from "./loadSpecificCombatantActions";
import useDeleteSlot from "../composables/useDeleteSlot";
import handleError from "../helpers/handleError";

import store from "../store/index";
//-------------------
// load action slots
//-------------------
export default function loadActionSlots(round, actions, markers) {
  console.log("--------------------");
  console.log("IN loadActionSlots...");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //----------------
  // get combatants
  //----------------
  if (combatants && combatants.length > 0) {
    // console.log("got combatants = " + combatants.length);
    //--------------------------------
    // get actions for specific round
    //--------------------------------
    let round_actions = [];
    if (actions && actions.length > 0) {
      // console.log("got actions = " + actions.length);
      round_actions = actions.filter((a) => a.round == round);
      // console.log(
      //   "got actions for round " + round + " = " + round_actions.length
      // );
    }
    //--------------------------------
    // get markers for specific round
    //--------------------------------
    let round_markers = [];
    if (markers && markers.length > 0) {
      // console.log("got markers = " + markers.length);
      round_markers = markers.filter((a) => a.round == round);
      // console.log(
      //   "got markers for round " + round + " = " + round_markers.length
      // );
    }
    //-----------------------------
    // loop thru active combatants
    //-----------------------------
    for (let i = 0; i < combatants.length; i++) {
      // console.log("###########################");
      // console.log(
      //   "i = " +
      //     i +
      //     " name = " +
      //     combatants[i].name +
      //     " ... off to loadSpecificCombatantActions"
      // );
      //---------------------------------------------------
      // load actions/markers for specific combatant/round
      //---------------------------------------------------
      let del_arrays = loadSpecificCombatantActions(
        round_actions,
        round_markers,
        i
      );
      //---------------------------------
      // delete actions where ca reduced
      //---------------------------------
      if (del_arrays.actions && del_arrays.actions.length > 0) {
        for (let i = 0; i < del_arrays.actions.length; i++) {
          //----------------------
          // delete action for ca
          //----------------------
          let call = useDeleteSlot(del_arrays.actions[i]);
          call.catch((err) => {
            handleError(err, 12);
          });
        }
      }
      //---------------------------------
      // delete markers where ca reduced
      //---------------------------------
      if (del_arrays.markers && del_arrays.markers.length > 0) {
        for (let i = 0; i < del_arrays.markers.length; i++) {
          //---------------------
          // delete marker for ca
          //----------------------
          let call = useDeleteSlot(del_arrays.markers[i]);
          call.catch((err) => {
            handleError(err, 13);
          });
        }
      }
    }
  }
}
